import { Injectable } from '@angular/core';
import { EmailService } from 'src/app/resources/services/email.service';
import { ApplicationProfileService } from './application-profile.service';

export interface UndefinedCssVariable {
  variable: string;
  value: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class CssValidatorService {
  constructor(private emailService: EmailService, private applicationProfileService: ApplicationProfileService) {}

  checkUndefinedCssVariables(componentName?: string): UndefinedCssVariable[] {
    const undefinedCssVariables: UndefinedCssVariable[] = [];

    document.querySelectorAll('*').forEach((el) => {
      const htmlElement = el as HTMLElement;
      if (htmlElement.style && htmlElement.style.length > 0) {
        for (let i = 0; i < htmlElement.style.length; i++) {
          const prop = htmlElement.style[i];
          if (prop.startsWith('--')) {
            const value = htmlElement.style.getPropertyValue(prop);
            if (value === 'undefined' || value === undefined || value === '' || value === 'null' || value === null) {
              undefinedCssVariables.push({
                variable: prop,
                value: value,
              });
            }
          }
        }
      }
    });

    if (undefinedCssVariables.length > 0) {
      // Send email notification when undefined CSS variables are found
      this.sendEmailNotification(undefinedCssVariables, componentName);
    }

    return undefinedCssVariables;
  }

  /**
   * Sends an email notification about undefined CSS variables
   * @param undefinedCssVariables Array of undefined CSS variables
   * @param componentName Optional name of the component
   */
  private sendEmailNotification(undefinedCssVariables: UndefinedCssVariable[], componentName?: string): void {
    var coalitionId: number = 0;

    this.applicationProfileService.applicationProfile$.subscribe((profile) => {
      coalitionId = profile.Merchant.MerchantId;
    });

    const subject = `[Merchant Portal Theme Variables] Undefined values detected ${
      componentName ? 'in ' + componentName : ''
    } on Merchant Portal of CoalitionId: ${coalitionId}.`;

    let messageContent = ` ${subject} The following CSS variables have undefined values:`;

    messageContent += 'Variables: \n';
    undefinedCssVariables.forEach((item, index) => {
      messageContent += `${item.variable}  \n`;
    });

    // Send the email notification
    this.emailService.sendEmail(messageContent).subscribe((response) => {
      if (response) {
        console.log('Email notification sent successfully');
      } else {
        console.warn('Failed to send email notification about undefined CSS variables');
      }
    });

    console.log(messageContent);
  }
}
